import { navigate } from '@/utils/navigation-service';

export const openSettings = (section: string, item?: string) =>
  navigate({
    to: '/settings/$section',
    params: { section },
    search: item ? { item } : {},
  });

export const parseSettingsHash = (hash: string) => {
  const [root, section, item] = hash.split('/');
  if (root !== 'settings' || !section) return null;
  return { section, item };
};
